import React,{useEffect} from 'react';

const Refund = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    return(
    <div style={{margin:'30px',padding:'40px'}}>
        <h1>RETURNS</h1>
<p><br/></p>
<p>----</p>
<p><br/></p>
<p>Our policy lasts 3 days. If 3 days have gone by since you received your order, unfortunately we can&rsquo;t offer you a refund or exchange.</p>
<p><br/></p>
<p>To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging.</p>
<p><br/></p>
<p>Several types of goods are exempt from being returned. Perishable goods such as food, flowers, newspapers or magazines cannot be returned. We also do not accept products that are intimate or sanitary goods, hazardous materials, or flammable liquids or gases.</p>
<p><br/></p>
<h3>Additional non-returnable items:</h3>
<ul>
    <li>Gift cards</li>
    <li>&nbsp;Downloadable software products</li>
    <li>&nbsp;Some health and personal care items</li>
    <li>Items that are on sale</li>
    <li>Wired Item</li>
</ul>
<p><strong>To complete your return, we require a receipt or proof of purchase.</strong></p>
<p><br/></p>
<p>Please do not send your purchase back to the manufacturer.</p>
<p><br/></p>
<p>There are certain situations where only partial refunds are granted: (if applicable)</p>
<ul>
    <li>&nbsp;Book with obvious signs of use</li>
    <li>CD, DVD, VHS tape, software, video game, cassette tape, or vinyl record that has been opened.</li>
    <li>Any item not in its original condition, is damaged or missing parts for reasons not due to our error.</li>
    <li>&nbsp;Any item that is returned more than 7 days after delivery</li>
</ul>
<p><br/></p>
<h3>Sale items (if applicable)</h3>
<p>Only regular priced items may be refunded, unfortunately sale items cannot be refunded.</p>
<p><br/></p>
<h3>Exchanges (if applicable)</h3>
<p>We only replace items if they are defective or damaged. &nbsp;If you need to exchange it for the same item, send us an email at acceronix@gmail.com and send your item to: HB Industries gadoon industrial state, Topi, SWABI, KP, 23245, Pakistan.</p>
<p>Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your exchange.</p>
<p>If you are approved, then your exchange will be processed, and a product will be sent to you on your address, within a certain amount of days.</p>
<p><br/></p>
<h3>Shipping</h3>
<p>To return your product, you should mail your product to: HB Industries gadoon industrial state, Topi, SWABI, KP, 23245, Pakistan.</p>
<p><br/></p>
<p>You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund.</p>
<p><br/></p>
<p>Depending on where you live, the time it may take for your exchanged product to reach you, may vary.</p>
<p><br/></p>
<p>You should consider using a trackable shipping service or purchasing shipping insurance. We don&rsquo;t guarantee that we will receive your returned item.</p>
    </div>
)}
export default Refund;